import { Col, Row, Spin } from 'antd'
import { useState } from 'react'
import './TasksLandingPage.style.less'

import {
  AlertFilled,
  CalendarFilled,
  CheckCircleFilled,
  CheckSquareOutlined,
  WarningFilled,
} from '@ant-design/icons'
import Header from '@/layout/components/Header'
import Fade from '@/components/Fade'
import { useNavigate } from 'react-router-dom'
import { setUrlParams, getUrlParams } from '@/utils/common'
import TasksMenuTile from './components/TaskMenuTile/TasksMenuTile'
import TaskTable from './TaskTable/TaskTable'
import { PriorityStatus } from '@/constant/task'
import { useTaskSummary } from './TaskTable/TaskTable.hook'

function TasksLandingPage() {
  const getFilterParams = getUrlParams('filter') || 'all'
  const [selectedFilter, setSelectedFilter] = useState<PriorityStatus | any>(
    getFilterParams
  )

  const [filterPayload, setFilterPayload] = useState({})

  const navigate = useNavigate()

  const { data: summary = {}, refetch } = useTaskSummary(filterPayload)

  const onTileClick = (current?: any) => {
    navigate({
      search: `?${setUrlParams('filter', current ?? '')}`,
    })
    setSelectedFilter(current ?? '')
  }

  return (
    <>
      <Header
        icon={<CheckSquareOutlined className="icon" />}
        title={'My Tasks'}
        background="linear-gradient(181.35deg, #247A70 1.15%, rgba(82, 169, 159, 1) 98.85%)"
      />

      <div className="pbf-landing-page-container tasks-landing-page-container">
        <Fade>
          <Row
            className="tasks-summary-tiles"
            gutter={[
              { xs: 12, sm: 12, md: 16, lg: 0 },
              { xs: 12, sm: 16, md: 16, lg: 0 },
            ]}
            justify="space-between"
            align="middle"
          >
            <Col xs={12} sm={8} md={8} lg={4}>
              <Spin spinning={false}>
                <TasksMenuTile
                  title="Active Tasks"
                  qty={summary?.totalTask || '0'}
                  color="#5B5B5B"
                  onClick={() => onTileClick('all')}
                  isSelected={selectedFilter === 'all'}
                />
              </Spin>
            </Col>
            <Col xs={12} sm={8} md={8} lg={4}>
              <Spin spinning={false}>
                <TasksMenuTile
                  title="Planned"
                  qty={summary[PriorityStatus.PLANNED] || '0'}
                  icon={<CalendarFilled />}
                  color="#4A8DC0"
                  onClick={() => onTileClick(PriorityStatus.PLANNED)}
                  isSelected={selectedFilter === PriorityStatus.PLANNED}
                />
              </Spin>
            </Col>
            <Col xs={12} sm={8} md={8} lg={4}>
              <Spin spinning={false}>
                <TasksMenuTile
                  title="Upcoming"
                  qty={summary[PriorityStatus.UPCOMING] || '0'}
                  icon={<WarningFilled />}
                  color="#EF9747"
                  isSelected={selectedFilter === PriorityStatus.UPCOMING}
                  onClick={() => onTileClick(PriorityStatus.UPCOMING)}
                />
              </Spin>
            </Col>
            <Col xs={12} sm={8} md={8} lg={4}>
              <Spin spinning={false}>
                <TasksMenuTile
                  title="Overdue"
                  qty={summary[PriorityStatus.OVERDUE] || '0'}
                  icon={<AlertFilled />}
                  color="#C03261"
                  isSelected={selectedFilter === PriorityStatus.OVERDUE}
                  onClick={() => onTileClick(PriorityStatus.OVERDUE)}
                />
              </Spin>
            </Col>
            <Col xs={12} sm={8} md={8} lg={4}>
              <Spin spinning={false}>
                <TasksMenuTile
                  title="Done"
                  qty={summary[PriorityStatus.DONE] || '0'}
                  icon={<CheckCircleFilled />}
                  color="#65BF73"
                  isSelected={selectedFilter === PriorityStatus.DONE}
                  onClick={() => onTileClick(PriorityStatus.DONE)}
                />
              </Spin>
            </Col>
          </Row>
          <div style={{ marginTop: 18 }}>
            <TaskTable
              refetchSummary={refetch}
              onFilterChange={setFilterPayload}
            />
          </div>
        </Fade>
      </div>
    </>
  )
}

export default TasksLandingPage
